
import Ajout from './Information/Ajout';
import './App.css';
import { Routes, Route,  } from 'react-router-dom';
import { Examens } from './Information/Examen.links';
import { Conctact } from './Information/Contact.links';
import { Candidat } from './Information/Candidat.links';
import { Accueil } from './Information/Accueil.links';
import AuthPage from './Information/Espace.links';



import './App.css';




function App() {

  //const imageUrl = 'logo ifc.png';
 
  return (
   <>
   
       <Routes> 
       <Route path = '/accueil' element={<Accueil/>}/>
       <Route path = '/faq' element={<Ajout/>}/>
        <Route path = '/examen' element={<Examens/>}/>
        <Route path = '/contact' element={<Conctact/>}/>
        <Route path = '/' element={<Candidat/>}/>
        <Route path = '/espCandidat' element={<AuthPage/>}/>
      </Routes>
    
    
  
 

  
    
    </>
  );
}

export default App;
